<ion-toolbar>
  <ion-title slot="start">{{ 'ios-pwa-prompt.title' | translate }}</ion-title>
  <ion-buttons slot="end">
    <ion-button (click)="dismiss()">
      {{ 'ios-pwa-prompt.close' | translate }}
    </ion-button>
  </ion-buttons>
</ion-toolbar>

<ion-content>
  <p *ngIf="isSafari" class="item-native">
    {{ 'ios-pwa-prompt.description' | translate }}
  </p>

  <p *ngIf="!isSafari" class="item-native">
    {{ 'ios-pwa-prompt.alt-description' | translate }}
  </p>

  <ion-list *ngIf="isSafari" lines="none">
    <ion-item>
      <ion-icon name="share-outline"></ion-icon>
      <ion-label>
        <p>
          {{ 'ios-pwa-prompt.step-1' | translate }}
        </p>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-icon name="add-circle-outline"></ion-icon>
      <ion-label>
        <p>
          {{ 'ios-pwa-prompt.step-2' | translate }}
        </p>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>
